export const moveKeyPress = (id, rowIndex) => {
    const el: any = document.getElementById(`${id}${rowIndex + 1}`);
    el?.select();
};
